import { mergeMap, withLatestFrom } from 'rxjs/operators';
import { push } from '@lagunovsky/redux-react-router';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { locationSelector } from '../_selectors/location.selector';
import { RouterAction } from '../router.action';

type IState =
  & IGetSelectorStateType<typeof locationSelector>;

export const removeLastPathParamEpic: IEpic<IState> = (action$, state$) => action$.pipe(
  isTypeOfAndGetPayload(RouterAction.removeLastPathParam),
  withLatestFrom(state$),
  mergeMap(([payload, state]) => {
    const { locationState } = payload;

    const location = locationSelector(state);
    const pathname = location.pathname.replace(/\/$/, '');
    const end = pathname.lastIndexOf('/');

    return [
      push({
        ...location,
        pathname: pathname.substring(0, end),
      }, locationState),
    ];
  }),
);
